import '../../client/index.js';
import { wrapErrorManager } from '../../utils/error-manager.js';
import { transformPostCrmRegisterResponse } from './transformers.js';
import { transformTokenV2Response } from '../auth/transformers.js';
import defaultClient from 'axios';

const postCrmLoginV2 = async ({ client , controller , email , password , source , recaptchaToken  } = {})=>{
    const params = new URLSearchParams({
        ...recaptchaToken ? {
            recaptchaToken
        } : {},
        ...source ? {
            source
        } : {}
    });
    return await client.post(`V2/crm/login${params.toString() ? `?${params.toString()}` : ''}`, {
        email,
        password
    }, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformTokenV2Response)
        ]
    });
};
postCrmLoginV2.key = 'postCrmLoginV2';
const postCrmRegister = async ({ client , controller , recaptchaToken , recaptchaAction , source , firstname , lastname , email , password , dob , additionalData ={}  } = {})=>{
    const params = new URLSearchParams({
        ...recaptchaToken ? {
            recaptcha_token: recaptchaToken
        } : {},
        ...recaptchaAction ? {
            recaptcha_action: recaptchaAction
        } : {},
        ...source ? {
            source
        } : {}
    });
    return await client.post(`V1/crm/register${params.toString() ? `?` + params.toString() : ''}`, {
        firstname,
        lastname,
        email,
        password,
        dob,
        additional_info: additionalData
    }, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformPostCrmRegisterResponse)
        ]
    });
};
postCrmRegister.key = 'postCrmRegister';
const postCrmSocialLoginV2 = async ({ client , controller , socialType , socialResponse , source  })=>{
    const params = new URLSearchParams({
        ...source ? {
            source
        } : {}
    });
    return await client.post(`V2/crm/social/login${params.toString() ? `?` + params.toString() : ''}`, {
        social_type: socialType,
        social_response: socialResponse
    }, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformTokenV2Response)
        ]
    });
};
postCrmSocialLoginV2.key = 'postCrmSocialLoginV2';

export { postCrmLoginV2, postCrmRegister, postCrmSocialLoginV2 };
